import { useEffect, useState } from "react";
import auctionImg from "../../assets/AuctionImg.jpeg";
import { Smartphone } from "lucide-react";
import DownloadModal from "../downloadModal/downloadModal";

// ── Web-app imports (kept for future use) ──
// import { toast } from "react-toastify";
// const moment = require("moment");
// ──────────────────────────────────────────

const AuctionCard = ({
  id: _id,
  title,
  imgURL,
  startDate,
  endDate,
  quantity: _quantity,
  price: _price,
  owner,
  products,
  subCategories = [],
  // user,           // not needed in promotional mode
  // creator_id,     // not needed in promotional mode
  // handleStartLive,   // not needed in promotional mode
  // hanldeJoinLive,    // not needed in promotional mode
  handleShowAuctionDetails,
  type,
}) => {
  const [targetDate] = useState(new Date(startDate.replace("Z", "")));
  const [remainingTime, setRemainingTime] = useState("");
  const [endDate1] = useState(new Date(endDate.replace("Z", "")));
  const [nowDate] = useState(new Date());
  const [differenceDate] = useState(endDate1 - nowDate);
  const [modalOpen, setModalOpen] = useState(false);

  useEffect(() => {
    const interval = setInterval(() => {
      const now = new Date();
      const difference = targetDate - now;

      if (difference > 0) {
        const hours = Math.floor((difference / (1000 * 60 * 60)) % 24);
        const minutes = Math.floor((difference / (1000 * 60)) % 60);
        setRemainingTime(
          `${String(hours).padStart(2, "0")}:${String(minutes).padStart(2, "0")}`
        );
      } else {
        setRemainingTime("00:00");
        clearInterval(interval);
      }
    }, 1000);

    return () => clearInterval(interval);
  }, [targetDate]);

  return (
    <>
      <DownloadModal open={modalOpen} setOpen={setModalOpen} />

      <div
        className="mt-4 flex flex-col md:flex-row items-center bg-white border border-gray-200 rounded-lg shadow hover:bg-gray-100 dark:border-gray-700 dark:bg-gray-800 dark:hover:bg-gray-700"
        style={{ width: "100%" }}
      >
        <img
          className="object-cover w-full rounded-t-lg md:h-auto md:w-48 md:rounded-none md:rounded-s-lg"
          src={process.env.REACT_APP_BASE_URL + imgURL}
          alt={title}
          onError={(e) => { e.target.src = auctionImg; }}
        />
        <div
          className="flex flex-col justify-between p-4 leading-normal"
          style={{ width: "100%" }}
        >
          <div className="mb-2 text-lg font-bold tracking-tight text-gray-900 dark:text-white">
            {title}
          </div>

          <div className="flex flex-wrap">
            {subCategories.map((subCategory, i) => (
              <span
                key={i}
                className="text-xs font-medium me-2 px-2.5 py-0.5 rounded-full mt-1"
                style={{ backgroundColor: "#F2F2F2", color: "#939597" }}
              >
                {subCategory.name} {subCategory.children[0].name}
              </span>
            ))}

            <span
              className="text-sm font-medium me-2 px-2.5 py-0.5 rounded-full mt-2"
              style={{ backgroundColor: "#F2F2F2", color: "#939597" }}
            >
              صاحب المزاد : {owner}
            </span>
            <span
              className="text-sm font-medium me-2 px-2.5 py-0.5 rounded-full mt-2"
              style={{ backgroundColor: "#F2F2F2", color: "#939597" }}
            >
              عدد السلع : {products.length}
            </span>
          </div>

          <div className="mt-4 flex flex-wrap gap-2">
            <span
              className="text-sm font-medium px-2.5 py-0.5 rounded-full cursor-pointer"
              style={{ backgroundColor: "black", color: "white" }}
              onClick={handleShowAuctionDetails}
            >
              مشاهدة تفاصيل المزاد
            </span>

            <span
              className="text-sm font-medium px-2.5 py-0.5 rounded-full"
              style={{ backgroundColor: "red", color: "white" }}
            >
              {differenceDate > 0
                ? `الوقت المتبقى ==> ${remainingTime}`
                : "لقد تم انتهاء المزاد"}
            </span>
          </div>

          {/* Download CTA — replaces the start/join buttons in promotional mode */}
          <button
            onClick={() => setModalOpen(true)}
            className="mt-4 flex items-center justify-center gap-2 w-full py-2.5 px-4 rounded-lg text-white font-bold transition-all duration-200 hover:scale-[1.02]"
            style={{ backgroundColor: "#00AEEB" }}
          >
            <Smartphone className="w-4 h-4" />
            <span>
              {type === "Live" ? "حمّل التطبيق لمشاهدة اللايف" : "حمّل التطبيق للمزايدة"}
            </span>
          </button>

          {/* ── Web-app action buttons (kept for future use) ──
          {user.id === creator_id ? (
            <button onClick={() => handleStartLive(id, type, startDate, endDate)} ...>
              {type === "Live" ? "ابدأ اللايف" : "المزاد"}
            </button>
          ) : (
            <button onClick={() => handleStartLive(id, type, startDate, endDate)} ...>
              {type === "Live" ? "مشاهدة اللايف" : "المزاد"}
            </button>
          )}
          ── */}
        </div>
      </div>
    </>
  );
};

export default AuctionCard;
